const TOKEN_FIELDS = ['accessToken', 'token', 'bearerToken'];

export function getLoginSession(response) {
  if (!response || typeof response !== 'object') return null;

  const user = response.data && typeof response.data === 'object'
    ? response.data
    : response;
  const tokenField = TOKEN_FIELDS.find(
    (field) => typeof user[field] === 'string' && user[field].trim(),
  );

  if (!tokenField) return null;

  return {
    token: user[tokenField],
    user,
  };
}
